module.exports = __webpack_public_path__ + "static/media/Lesson-2-5-Everyone-Counts-in-the-Church.8d276a7e.pdf";